// The files in the platform agent's message box (D6, docs/platform-agent/contracts.md §8). The label, placeholder
// and hint stay in PlatformAgentConversation's `composer`.
export default {
  drop: 'Largue os ficheiros aqui: PDF, fotos, Excel, CSV ou Word',
  waiting: 'O envio aguarda até os ficheiros serem carregados.',
  // A PDF's pages on its tile (B37): "PDF · 1.2 MB · 4 pages".
  pages_one: '{{count}} página',
  pages_other: '{{count}} páginas',
  problems: {
    type: 'Este tipo de ficheiro não pode ser enviado. Envie um PDF, uma foto (JPG, PNG ou HEIC) ou um ficheiro Excel, CSV ou Word.',
    size: 'Mais de 20 MB. Um ficheiro pode ter até 20 MB.',
    empty: 'Este ficheiro está vazio.',
    count: 'Até 10 ficheiros por mensagem.',
    upload: 'O carregamento foi interrompido. Tente novamente.',
  },
};
